import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, Col } from 'reactstrap';
import VisitorsCardHeader from './VisitorsCardHeader';
import { VISITOR_CARD_OPTION } from '../../../../Data/Widgets/GeneralWidgets';

const VisitorsCard = () => {
  return (
    <Col xxl="5" xl="3" md="12" className='box-col-12'>
    <Card className='visitor-card'>
      <VisitorsCardHeader />
      <CardBody className='pt-3'>
        <div className='visitors-container'>
          <ReactApexChart height={270} type='bar' options={VISITOR_CARD_OPTION} series={VISITOR_CARD_OPTION.series} />
        </div>
      </CardBody>
    </Card>
    </Col>
  );
};

export default VisitorsCard;
